import { Container, Stack } from "@octopus-energy/coral/atoms"
import CustomHead from "@/components/atoms/CustomHead"
import { Page } from "@/components/organisms"
import { type SbLandingStory } from "../../../../types"
import { Hero } from "../../../Hero"
import { StoryblokBlokLooper } from "../../../StoryblokBlokLooper"

type LandingTemplateProps = {
    story: SbLandingStory
}

export function LandingTemplate({ story }: LandingTemplateProps) {
    const { src, imageWidth, metadata, imageHeight, title, blocks, heroBlocks } = story.content

    return (
        <>
            <CustomHead
                title={metadata?.title}
                description={metadata?.description}
            />
            <Container component="article">
                <Stack flexDirection="column">
                    <Container component="header">
                        <Page>
                            <Stack flexDirection="column">
                                <Hero
                                    title={title}
                                    image={src}
                                    imageWidth={imageWidth}
                                    imageHeight={imageHeight}
                                >
                                    {heroBlocks && <StoryblokBlokLooper blocks={heroBlocks} />}
                                </Hero>
                            </Stack>
                        </Page>
                    </Container>

                    <StoryblokBlokLooper
                        required
                        blocks={blocks}
                    />
                </Stack>
            </Container>
        </>
    )
}
